import React from "react";
import { Card, CardBody } from "reactstrap";
import { H4 } from "../../../../../../AbstractElements";
import { ArrowDown, ArrowUp } from "react-feather";
import "./kpi.css"
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { convertToLocalTimezone } from '../../../../../../utils/formatDate';

const KPICard = ({ data, mainClass,AImachine }) => { 
  console.log(AImachine)
  return (
    <Card
      className={`small-widget ${mainClass}`}
      style={{
        // marginRight: data?.marginRight,
        // marginLeft: data?.marginLeft,
        marginBottom: 5,
        
      }}
    >
      <CardBody className={data.color} style={{position:'relative'}}>
        <p
          className="para justify-items-center align-items-center px-3 py-2 rounded mb-2"
          style={{ backgroundColor: data.gateColor, width: "fit-content", height: 'fit-content' }}
        >
          {data.title } { data.titleInactive ? data.titleInactive : ''}
        </p>
        <div className="d-flex align-items-end gap-4 justify-content-between">
          <div className="d-flex gap-4 gap-sm-5">
          <H4 attrH4={{className: 'px-3'}}>{data.total}</H4> 
          { data?.InActiveCount ? <H4 attrH4={{className: 'px-3 text-danger'}}>{data.InActiveCount}</H4> : ''}
          </div>
          
          {data?.showPercentage && (
            <span className={`font-${data.color} f-14 f-w-500`}>
              {data.gros > 0 &&  data.gros < 50 ? (
                <ArrowDown size={20} className="font-danger" />
              ) :data.gros > 0 ? (
                <ArrowUp size={20} className="font-success" />
              ): null}
             {data.gros > 0 &&<span
             style={{fontSize:'22px'}}
                className={`px-1 ${ 
                   parseFloat(data.gros) < 50 ? "font-danger" :  "font-success" 
                }`}
              >
                {/* {  parseFloat(data.gros) < 50 ? "-" : "+"} */}
                {data.gros}%
              </span>}
            </span>
          )}
        </div>
    
        {AImachine && 
                  <div style={{position:'absolute',right:'15px',bottom:'15px'}} >
                    <span className="f-light me-2">AI Machine status: </span>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="bottom"
                    overlay={
                      <Popover id="popover-basic">
                        <Popover.Header as="h3">AI Machine is {AImachine?.state} <span className='f-light' style={{fontSize:'10px'}}>{AImachine?.factory_name}</span> </Popover.Header>
                        <Popover.Body> 
                          <ul>
                            <li className='mb-1'>
                                <b>Message</b>: {AImachine?.message}
                            </li> 
                            <li className='mb-1'>
                                <b>Description</b>: {AImachine?.description}
                            </li>  
                            <li>
                                <b>Time</b>: {convertToLocalTimezone(AImachine?.created_at)}
                            </li>
                          </ul>
                        
                        </Popover.Body>
                      </Popover>
                    }
                  >
                     <Button variant="primary" className={`${AImachine?.state == 'offline' ? "pop-hover-btn" : "pop-hover-btn2"}`}> {AImachine?.state || "AI Machine" }</Button>
                  </OverlayTrigger>
                  </div> }
 
      </CardBody>
    </Card>
  );
};

export default KPICard;
